import Model from '@/models/Model'
import User, { hasRole, Role } from '@/models/User'

export default class Gate {
	private policies: object

	constructor(private user: User | null) {
		this.policies = {}

		//const files = import.meta.env.PROD ? import.meta.glob('@/policies/*Policy*') : import.meta.glob('@/policies/*Policy*', { eager: true })
		const files = import.meta.glob('@/policies/*Policy*', { eager: true })

		for (let path in files) {
			let name = path
				.substring(path.lastIndexOf('/') + 1)
				.replace(/Policy\.ts$/, '')
				.toLowerCase()

			// @ts-ignore
			this.policies[name] = files[path]?.default
		}
	}

	before() {
		if (!this.user) return false

		return hasRole(this.user, [Role.ADMIN, Role.MANAGER, Role.REGULATOR])
	}

	allow(action: string, model: Model | string) {
		if (this.before()) return true

		let type = typeof model === 'object' ? model.model : model

		// eslint-disable-next-line no-prototype-builtins
		if (this.user && this.policies.hasOwnProperty(type) && typeof new this.policies[type]()[action] === 'function') {
			return new this.policies[type]()[action](this.user, typeof model === 'object' ? model : null)
		}

		return false
	}

	deny(action: string, model: Model) {
		return !this.allow(action, model)
	}

	admin() {
		if (!this.user) return false

		return hasRole(this.user, Role.ADMIN) && import.meta.env.VITE_APP_ENV !== 'production'
	}
}
